import moment from 'moment'

const getFormatedDate = (date, format = 'YYYY-MM-DD', fromFormat = null) => date
    ? moment(date, fromFormat).format(format)
    : null

export default {
    getFormatedDate,
    createIdKeysToObject: (data, keys, stringCase = 'camel') => {

        let idKey = ''

        switch (stringCase) {

            case 'camel':
                idKey = 'Id'
                break
            case 'snake':
                idKey = '_id'
                break
        }

        keys.forEach(key => {

            data[`${key}${idKey}`] = data[key] instanceof Object ? (data[key].id || null) : data[key]

            delete data[key]
        })

        return data
    },
    formateDates: (data, keys, format = 'YYYY-MM-DD') => {

        keys.forEach(key => {

            if (data[key] instanceof Date) {

                data[key] = getFormatedDate(data[key], format)
            }
        })
    },
    loadDataFromSourceObject: (source, target, loadObjects = false) => {

        for (const key in target) {
            if (Object.prototype.hasOwnProperty.call(source, key)
                && (source[key] instanceof Date || loadObjects || !(source[key] instanceof Object))
            ) {

                target[key] = source[key]
            }
        }
    },
    getDateObject: dateString => {

        if (dateString === null || dateString.trim() === '') {

            return null
        }

        if (dateString.indexOf('-') !== -1) {

            const date = dateString.split('-')

            return new Date(date[0], date[1] - 1, date[2])
        }

        if (dateString.indexOf('/') !== -1) {

            const date = dateString.split('/')

            return new Date(date[2], date[1] - 1, date[0])
        }
    },
    getDateTimeObject: dateTimeString => {

        if (dateTimeString === null || dateTimeString.trim() === '' || dateTimeString.indexOf(':') === -1) {

            return null
        }

        if (dateTimeString.indexOf('-') !== -1) {

            const dateTime = dateTimeString.split(' ')
            const date = dateTime[0].split('-')
            const hora = dateTime[1].split(':')

            return new Date(date[0], date[1] - 1, date[2], hora[0], hora[1], hora[2])
        }

        if (dateTimeString.indexOf('/') !== -1) {

            const dateTime = dateTimeString.split(' ')
            const date = dateTime[0].split('/')
            const hora = dateTime[1].split(':')

            return new Date(date[2], date[1] - 1, date[0], hora[0], hora[1], hora[2])
        }
    },
    isNullOrEmptyString(value) {

        return value === null || (typeof value === 'string' && value.trim() === '')
    },
    isNullOrEmptyObject(value) {
        for (let key in value) {
            if (value[key] !== null && value[key] !== false && value[key] !== '')
                return false
        }

        return true
    },
    isObject(obj) {

        return obj === Object(obj)
            && !Array.isArray(obj)
            && typeof obj !== 'function'
    }
}